const DirectoryScreen = {
  DIRECTORY: {
    PATH: '/directory/',
    TITLE: 'Directory',
    TITLE_ALT: 'Directory',
    PERMISSION: 'manage_mall.read',
  },
  MALL: {
    PATH: '/directory/mall/index',
    TITLE: 'Mall',
    TITLE_ALT: 'Mall',
    PERMISSION: 'manage_mall.read',
  },
  STORE_CATEGORY: {
    PATH: '/directory/store-category/index',
    TITLE: 'Store Category',
    TITLE_ALT: 'Store Category',
    PERMISSION: 'manage_store_category.read',
  },
  STORE: {
    PATH: '/directory/store/index',
    TITLE: 'Store / Facility',
    TITLE_ALT: 'Store / Facility',
  },
  ADD_STORE: {
    PATH: '/directory/store/add',
    TITLE: 'Add Store',
    TITLE_ALT: 'Add Store',
    PERMISSION: 'manage_store.create',
  },
  DETAIL_STORE: {
    PATH: '/directory/store/detail/:id',
    TITLE: 'Detail Store',
    TITLE_ALT: 'Detail Store',
    PERMISSION: 'manage_store.read',
  },
  EDIT_STORE: {
    PATH: '/directory/store/edit/:id',
    TITLE: 'Edit Store',
    TITLE_ALT: 'Edit Store',
    PERMISSION: 'manage_store.update',
  },
  STORE_TABS: {
    PATH: '/directory/store/list/:path',
    TITLE: 'Store / Facility',
    TITLE_ALT: 'Store / Facility',
  },
  LIST_PARTNER: {
    PATH: '/directory/store/list/partner',
    TITLE: 'Partner',
    TITLE_ALT: 'Partner',
    PERMISSION: 'manage_partner.read',
  },
  ADD_PARTNER: {
    PATH: '/directory/partner/add',
    TITLE: 'Add Partner',
    TITLE_ALT: 'Add Partner',
    PERMISSION: 'manage_partner.create',
  },
  DETAIL_PARTNER: {
    PATH: '/directory/partner/detail/:id',
    TITLE: 'Detail Partner',
    TITLE_ALT: 'Detail Partner',
    PERMISSION: 'manage_partner.read',
  },
  EDIT_PARTNER: {
    PATH: '/directory/partner/edit/:id',
    TITLE: 'Edit Partner',
    TITLE_ALT: 'Edit Partner',
    PERMISSION: 'manage_partner.update',
  },
  LIST_FACILITY: {
    PATH: '/directory/store/list/facility',
    TITLE: 'Facility',
    TITLE_ALT: 'Facility',
    PERMISSION: 'manage_facility.read',
  },
  ADD_FACILITY: {
    PATH: '/directory/facility/add',
    TITLE: 'Add Facility',
    TITLE_ALT: 'Add Facility',
    PERMISSION: 'manage_facility.create',
  },
  DETAIL_FACILITY: {
    PATH: '/directory/facility/detail/:id',
    TITLE: 'Detail Facility',
    TITLE_ALT: 'Detail Facility',
    PERMISSION: 'manage_facility.read',
  },
  EDIT_FACILITY: {
    PATH: '/directory/facility/edit/:id',
    TITLE: 'Edit Facility',
    TITLE_ALT: 'Edit Facility',
    PERMISSION: 'manage_facility.update',
  },
};

export default DirectoryScreen;

